
import { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Menu, X } from 'lucide-react';
import TaxbyLogo from "@/components/TaxbyLogo";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [onHero, setOnHero] = useState(true);
  
  useEffect(() => {
    const hero = document.getElementById("hero");
    if (!hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => setOnHero(entry.isIntersecting),
      { threshold: 0.12, rootMargin: "-64px 0px 0px 0px" }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navLinkClass = onHero
    ? "font-medium text-white/90 hover:text-white transition-colors"
    : "font-medium text-gray-700 hover:text-taxby-purple transition-colors";

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        onHero
          ? "bg-transparent py-5"
          : "bg-white/95 backdrop-blur-md shadow-md py-3"
      }`}
    >
      <div className="container mx-auto flex items-center justify-between px-4">
        <TaxbyLogo variant={onHero ? "light" : "dark"} showTagline={onHero} />

        <nav className="hidden md:flex items-center space-x-6">
          <a href="#features" className={navLinkClass}>Funcionalidades</a>
          <a href="#ai" className={navLinkClass}>IA</a>
          <a href="#benefits" className={navLinkClass}>Beneficios</a>
          <a href="#pricing" className={navLinkClass}>Precios</a>
          <a href="#faq" className={navLinkClass}>FAQ</a>
          <Button 
            onClick={() => document.getElementById('subscribe')?.scrollIntoView({ behavior: 'smooth' })}
            className={
              onHero
                ? "rounded-full bg-white text-taxby-violet hover:bg-white/90"
                : "rounded-full bg-taxby-purple hover:bg-taxby-violet text-white"
            }
          >
            Lista de espera
          </Button>
        </nav>
        
        <div className="md:hidden">
          <button 
            onClick={toggleMenu}
            className={`p-2 ${onHero ? "text-white" : "text-gray-800"}`}
            aria-label="Menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      <div className={`md:hidden absolute w-full transition-all duration-300 ease-in-out ${
        onHero ? "bg-taxby-violet-deep/95" : "bg-white/95"
      } backdrop-blur-md shadow-lg ${
        isOpen ? "max-h-screen py-5 opacity-100" : "max-h-0 py-0 opacity-0 overflow-hidden"
      }`}>
        <div className="container mx-auto px-4 flex flex-col space-y-4">
          <a href="#features" className={`${navLinkClass} py-2`} onClick={() => setIsOpen(false)}>Funcionalidades</a>
          <a href="#ai" className={`${navLinkClass} py-2`} onClick={() => setIsOpen(false)}>IA</a>
          <a href="#benefits" className={`${navLinkClass} py-2`} onClick={() => setIsOpen(false)}>Beneficios</a>
          <a href="#pricing" className={`${navLinkClass} py-2`} onClick={() => setIsOpen(false)}>Precios</a>
          <a href="#faq" className={`${navLinkClass} py-2`} onClick={() => setIsOpen(false)}>FAQ</a>
          <Button 
            onClick={() => {
              document.getElementById('subscribe')?.scrollIntoView({ behavior: 'smooth' });
              setIsOpen(false);
            }}
            className={
              onHero
                ? "w-full rounded-full bg-white text-taxby-violet hover:bg-white/90"
                : "w-full rounded-full bg-taxby-purple hover:bg-taxby-violet text-white"
            }
          >
            Lista de espera
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
